export const isCloud = (code: string): boolean => code.startsWith('CL');

export const isEdu = (code: string): boolean =>
  code.length > 9 && (code[9] === 'N' || code[9] === 'S');

/** Corona and V-Ray share one licence family for eligibility purposes. */
const VRAY_FAMILIES = ['CS', 'VR'];

export const productFamily = (code: string): string => code.substring(0, 2);

export const isFamilyIneligible = (
  family: string,
  ineligibleFamilies: string[],
): boolean =>
  VRAY_FAMILIES.includes(family)
    ? VRAY_FAMILIES.some((f) => ineligibleFamilies.includes(f))
    : ineligibleFamilies.includes(family);

export const getCookie = (cName: string) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${cName}=`);

  return parts.length === 2 ? (parts.pop()?.split(';').shift() ?? '') : '';
};

/** `maxAgeSeconds` is in seconds, matching the Set-Cookie `max-age` attribute. */
export const setCookie = (
  cName: string,
  value: string,
  domain: string,
  maxAgeSeconds: number,
) => {
  // biome-ignore lint/suspicious/noDocumentCookie: the Cookie Store API is unavailable in Safari and Firefox, so document.cookie stays the portable option.
  document.cookie = `${cName}=${value};domain=${domain};path=/;max-age=${maxAgeSeconds};samesite=lax`;
};
